<template>
  <div class="slider-verify">
    <div class="slider-mask" :class="{'animation': resetAnimation}" :style="{width: sliderWidth + 'px',}">
      <div class="slider-pass-text" v-if="isPass">验证通过</div>
      <div class="slider-block" :class="[isPass ? 'pass' : '']"  @mousedown="mousedown">
      </div>
    </div>
    <div class="slider-text" v-if="!isPass && !startMouse">请按住滑块，拖动到最右边</div>
    
  </div>
</template>
<script>
export default {
  name: 'slider-verify',
  data() {
    return {
      isPass: false,
      sliderLeft: 0, // 小滑块的滑动距离
      sliderMaxWidth: 0, // 整体的宽度
      startMouse: false, // 是否开始滑动
      originX: 0, // 滑动时的初始X值
      resetAnimation: false,
    };
  },
  computed: {
    sliderWidth() {
      return this.isPass ? this.sliderMaxWidth - 64 : this.sliderLeft;
    },
  },
  watch: {
    isPass(value) {
      this.$emit('input', value);
    },
  },
  mounted() {
    this.initSlider();
  },
  destroyed() {
    document.removeEventListener('mousemove', this.mousemove);
    document.removeEventListener('mouseup', this.mouseup);
  },
  methods: {
    initSlider() {
      const el = document.querySelector('.slider-verify');
      this.sliderMaxWidth = el.offsetWidth;
      document.addEventListener('mousemove', this.mousemove);
      document.addEventListener('mouseup', this.mouseup);
    },
    mousedown(e) {
      if (this.isPass || this.resetAnimation) return;
      this.originX = e.clientX || e.touches[0].clientX;
      this.startMouse = true;
    },
    mousemove(e) {
      if (!this.startMouse || this.isPass) return;
      const eventX = e.clientX || e.touches[0].clientX;
      const moveX = eventX - this.originX;
      if (moveX < 0) return;
      if (moveX >= this.sliderMaxWidth - 64) {
        this.sliderLeft = this.sliderMaxWidth - 64;
        this.isPass = true;
        return;
      }
      this.sliderLeft = moveX;
    },
    mouseup() {
      if (!this.startMouse || this.isPass) return;
      this.startMouse = false;
      if (this.sliderLeft >= this.sliderMaxWidth - 64) {
        this.isPass = true;
      } else {
        this.isPass = false;
        this.reset();
      }
    },
    reset() {
      this.resetAnimation = true;
      this.sliderLeft = 0;
      setTimeout(() => {
        this.resetAnimation = false;
      }, 150);
    },
  },
};
</script>
<style lang="less" scoped>
.slider-verify{
  width: 100%;
  height: 48px;
  background: #F3F6F9;
  border-radius:2px;
  position: relative;
  &::after{
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    border: 1px solid #E9EEF2;
    border-radius:2px;
  }
  .slider-mask{
    background: #17CEBB;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px 0 0 2px;
    &.animation{
      transition: 0.15s width ease-out;
    }
    .slider-pass-text{
      font-size: 16px;
      color: #fff;
      line-height: 1;
      user-select: none;
    }
    .slider-block{
      position: absolute;
      left: 100%;
      top: 0;
      z-index: 9;
      height: 100%;
      width: 65px;
      cursor: grab;
      border: 1px solid #DEE2E6;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url(https://o.666visa.cn/static/ssqwxa/register/icon-right.png) #fff no-repeat center center;
      background-size: 32px 16px;
      &.pass{
        background: url(https://o.666visa.cn/static/ssqwxa/register/icon-pass.png) #fff no-repeat center center;
        background-size:20px 20px;
      }
    }
  }
  .slider-text{
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    color: #91999F;
    font-size: 16px;
    line-height: 1;
    user-select: none;
  }
  
  
}
</style>


// WEBPACK FOOTER //
// src/components/common/login/components/slider-verify.vue